/**
 * Unilar BF FAQ
 * Exclusive accordion (one open at a time) + aria-expanded sync.
 */

class UnilarBfFaq {
  constructor(section) {
    this.section = section;
    this.items = Array.from(section.querySelectorAll('[data-bf-faq-item]'));
    this.init();
  }

  init() {
    if (!this.items.length) return;

    this.items.forEach((item) => {
      if (!(item instanceof HTMLDetailsElement)) return;

      const trigger = item.querySelector('[data-bf-faq-trigger]');
      this.syncAria(item, trigger);

      item.addEventListener('toggle', () => {
        this.syncAria(item, trigger);

        if (!item.open) return;

        this.items.forEach((other) => {
          if (other !== item && other instanceof HTMLDetailsElement && other.open) {
            other.open = false;
          }
        });
      });
    });
  }

  syncAria(item, trigger) {
    if (!(trigger instanceof HTMLElement)) return;
    trigger.setAttribute('aria-expanded', item.open ? 'true' : 'false');
  }
}

function initUnilarBfFaq() {
  document.querySelectorAll('[data-unilar-bf-faq]').forEach((section) => {
    if (!(section instanceof HTMLElement) || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    new UnilarBfFaq(section);
  });
}

document.addEventListener('DOMContentLoaded', initUnilarBfFaq);
document.addEventListener('shopify:section:load', initUnilarBfFaq);
document.addEventListener('shopify:section:reorder', initUnilarBfFaq);

if (document.readyState === 'interactive' || document.readyState === 'complete') {
  initUnilarBfFaq();
}
